import { isEmpty } from '@skylab-shared/utils';
import { Violation, ViolationSeverity } from './../violation';
import { getPropertyRulesFor, updatePropertyRulesFor } from './utils';

export class RequiredError extends Violation {
    public constructor(message: string) {
        super(ViolationSeverity.Error, message);
    }
}

export function Required(message?: string): PropertyDecorator {
    return (target: Object, propertyKey: string | symbol): void => {
        const key = propertyKey as string;
        const propertyRules = getPropertyRulesFor(target, key);
        const violation = message || `Property {${target.constructor.name}.${key}} is required.`;

        propertyRules.push([{
            async: false,
            violationType: RequiredError.bind(null, violation),
            validate: context => {
                const value = context.source[key];
                const isNumber = typeof value === 'number';
                const isString = typeof value === 'string';
                const isEmptyString = isString && value.trim() === '';
                const empty = (isEmpty(value) && !isNumber && !isString) || (isNumber && value === 0) || isEmptyString;
                return !empty;
            }
        }, void 0]);

        updatePropertyRulesFor(target, key, propertyRules);
    };
}
